module.exports = __webpack_public_path__ + "img/log_dark_1.a95ef468.png";